import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	setSecretCode,
	type SetSecretCodeErrorResponse,
	type SetSecretCodeRequest,
	type SetSecretCodeResponse,
} from '../../http';

export function useSetSecretCode(
	options?: UseMutationOptions<SetSecretCodeResponse, AxiosError<SetSecretCodeErrorResponse>, SetSecretCodeRequest>,
): UseMutationResult<SetSecretCodeResponse, AxiosError<SetSecretCodeErrorResponse>, SetSecretCodeRequest> {
	return useMutation<SetSecretCodeResponse, AxiosError<SetSecretCodeErrorResponse>, SetSecretCodeRequest>(
		(request) => setSecretCode(request).then(({data}) => data),
		options,
	);
}
